<template>
  <div>
    <CCard>
      <CCardHeader>
        {{ $t("Campaigns") }}
        <div class="card-header-actions">
          <CButton
            class="mz-button v2-mz-btn mr-2"
            color="primary"
            v-if="isAdministrator"
            @click="newCampaign"
          >
            {{ $t("Create") }}
            <em class="ml-2 fa fa-plus color-inherit" />
          </CButton>
        </div>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CampaignCard
            v-for="campaign in campaigns"
            :key="campaign.id"
            :campaign="campaign"
            class="campaign-card"
          >
          </CampaignCard>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { ActiveUser } from "@/services/user";
import { CampaignServices } from "@/services/campaigns";
import CampaignCard from "./CampaignCard";

export default {
  name: "Campaigns",
  components: { CampaignCard },
  data() {
    return {
      isAdministrator: ActiveUser.isAdministrator(),
      campaigns: [],
    };
  },
  async mounted() {
    await this.fetchItems();
  },
  methods: {
    sortById(a, b) {
      return new Date(b.id_campaign) - new Date(a.id_campaign);
    },
    async fetchItems() {
      this.campaigns = await CampaignServices.fetchCampaigns();
      this.campaigns.sort(this.sortById);
    },
    newCampaign() {
      this.$router.push({ name: "New Campaign" });
    },
  },
};
</script>

<style lang="scss" scoped>
.campaign-card {
  margin: 1em;
  min-width: 375px;
  max-width: 500px;
}
</style>
